
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppTable } from '@/components';
import { useAppList } from '@/modules/apps/model/list';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';
import { useAuthStore } from '@/modules/auth/store';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/modules/apps/store';

export default defineComponent({
    name: ROUTE_NAME_APPLICATION.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const authStore = useAuthStore();
        const appStore = useAppStore();

        const { list, total, fetchList } = useAppList();
        const { appId } = storeToRefs(appStore);
        const { isSuperUser } = storeToRefs(authStore);

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Status', key: 'status' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_APPLICATION.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-users',
                        theme: 'info',
                        tooltip: 'Accounts',
                        to: { name: ROUTE_NAME_ACCOUNT.APP.INDEX, params: { appId: row.id } }
                    }),
                    canShow: row => row.id === appId.value
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, isSuperUser, ROUTE_NAME_APPLICATION };
    }
});
